<script setup lang="ts">
import type { Subject } from "~/types/subject"

const props = defineProps<{ chapter: Subject }>()

const { imageType } = useChapterCard({
  chapter: props.chapter,
})

const classes = useThemedClasses(() => props.chapter.colorTag)

const textColorClass = computed(() =>
  imageType.value === "backgroundImage"
    ? "text-white"
    : classes.value.bwText(),
)
</script>

<template>
  <div class="space-y-4 lg:w-[45%]" :class="[textColorClass]">
    <UContentFreeLabel v-if="chapter.showFreeLabel" small />
    <div>
      <h3
        class="mb-1 line-clamp-2 font-national2compressed text-mobile-chaper-preview-h1 leading-10 lg:text-desktop-chapter-preview-h1"
      >
        {{ chapter.priority }}. {{ chapter.title }}
      </h3>
      <UMediaTypes
        :data="chapter"
        :background-image-class="textColorClass"
      />
    </div>
  </div>
</template>
